export default {
  name: 'membership',
  path: 'membership',
  component: () => import(/* webpackChunkName: "membership" */ './index.vue')
}
